import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../res/actions';
import { Spinner } from '@amzn/awsui-components-react/polaris';
import ChallengesTable from './ChallengesTable';

const mapStateToProps = (state) => {
  return { domains: state.domains, loading: state.appState.isLoading }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ 
    addNotification: actionCreators.addNotification,
    clearAllNotifications: actionCreators.clearAllNotifications,
    setLoadingToTrue: actionCreators.setLoadingToTrue, 
    setLoadingToFalse: actionCreators.setLoadingToFalse
  },dispatch);
}


class Challenges extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      domainId : this.props.match.params.domainId,
    }
  }
  static getDerivedStateFromProps(props, state){
      if(props.match.params.domainId !== state.domainId){
          const resp = {
              domainId : props.match.params.domainId,
            };
          return resp;
      }
      else
          return null;     
  }
  render(){
    if(this.props.isLoading){
      return(
        <div>
          <Spinner size="large"></Spinner>
        </div>
      );
    }
    return(
      <div id='challenge_table_container'>
        <ChallengesTable domainId={this.state.domainId} {...this.props}/>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Challenges);



// WEBPACK FOOTER //
// ./src/app/components/Challenges.jsx